import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import Breadcrumb from '../Breadcrumb';
import { logoutUser } from '../../actions/user';
import "./AdminManagement.css";

const AdminMasterList = React.memo(
  ({ isFetching, data, count, fetchAdminList, user_info, fetchUserInfo }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 200;

    const totalPages = Math.ceil(count / itemsPerPage);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
      fetchUserInfo();
      fetchAdminList();
    }, [fetchUserInfo, fetchAdminList, location.state?.reloadAt]);

    const paginatedData = data.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    return (
      <div id="Main">
        <div id="Contents">

          <Breadcrumb
            user={user_info?.admin_name}
            onLogout={() => dispatch(logoutUser())}
          />

          <div className="admin-master-layout">

            {/* HEADER CARD */}
            <div className="admin-header-card">
              <h2 className="admin-title">管理者一覧</h2>

              <button className="admin-register-btn" onClick={() => navigate("/admin-list/create")}>新規登録</button>

              <div className="table-container">
                {/* TABLE */}
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>ログインID</th>
                      <th>ユーザー名</th>
                      <th>編集</th>
                    </tr>
                  </thead>

                  <tbody>
                    {!isFetching && paginatedData.map((item, index) => (
                      <tr key={item.admin_id || index}>
                        <td>{item.login_id}</td>
                        <td>{item.admin_name}</td>
                        <td>
                          <button
                            className="admin-edit-btn"
                            onClick={() => navigate(`/admin-list/edit/${item.admin_id}`)}
                          >
                            編集
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
            </div>

            {/* FOOTER */}
            <div className="footer-wrapper">
              <div className="admin-footer">件数：{count}</div>
              <div className="pagination-center">
                <div className="pagination-container">
                    <button
                      className="page-btn"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(1)}
                    >
                      ≪
                    </button>

                    <button
                      className="page-btn"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(prev => prev - 1)}
                    >
                      ＜
                    </button>

                    {/* Page numbers */}
                    {[...Array(totalPages)].map((_, idx) => {
                      const page = idx + 1;
                      return (
                        <button
                          key={page}
                          className={`page-number-btn ${page === currentPage ? "active" : ""}`}
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      );
                    })}

                    <button
                      className="page-btn"
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(prev => prev + 1)}
                    >
                      ＞
                    </button>

                    <button
                      className="page-btn"
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      ≫
                    </button>

                </div>
              </div>

              <div className="footer-empty"></div>
            </div>

          </div>
        </div>
        <div className={`overlay ${isFetching ? 'active' : ''}`}>
          <div className={`spinner ${isFetching ? 'active' : ''}`}></div>
        </div>
      </div>
    );
  }
);

AdminMasterList.displayName = "AdminMasterList";    // fix eslint(react/display-name)

AdminMasterList.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    user_info: PropTypes.object,
    data: PropTypes.array,
    count: PropTypes.number,
    error: PropTypes.any,
    fetchAdminList: PropTypes.func.isRequired,
    fetchUserInfo: PropTypes.func.isRequired,
};

export default AdminMasterList;
